<div class="footer ">
	<p class="paragraph mb-2 ml-3">
		© Shoqata e Sigurimeve të Kosovës
	</p>
	<p class="paragraph mb-2">
		Developed & Maintained by
		<a href="https://www.thequantix.com/" target="_blank" class="ml-1">
			<img
				src="../../../../assets/images/quantix-logo.svg"
				alt="quantix-logo"
			/>
		</a>
	</p>
	<a class="footer-links mr-3" routerLink="/terms">
		Termat dhe Kushtet
	</a>
</div>

<div class="footer-responsive ">
	<a class="footer-links mb-2" routerLink="/terms">
		Termat dhe Kushtet
	</a>
	<p class="paragraph mb-2">
		Developed & Maintained by
		<a href="https://www.thequantix.com/" target="_blank" class="ml-1">
			<img
				src="../../../../assets/images/quantix-logo.svg"
				alt="quantix-logo"
			/>
		</a>
	</p>
	<p class="paragraph">
		© Shoqata e Sigurimeve të Kosovës
	</p>
</div>
